// Откуда пришёл клиент — единый список для банкротства и гражданских дел (аналитика по источникам)
export const LEAD_SOURCES = [
  'Группа ВК', 'Канал MAX', 'Авито', 'Яндекс Карты', '2ГИС', 'Google Карты', 'Поиск Яндекс', 'Поиск Google',
  'Сайт', 'Ролики ВК/YouTube', 'Листовка', 'Рекомендация', 'Знакомые', 'От пристава', 'Яндекс Директ', 'Другое',
];

// Варианты для <select>: список + старое значение записи, если его в списке нет (чтобы не потерять при сохранении)
export const sourceOptions = current =>
  current && !LEAD_SOURCES.includes(current) ? [current, ...LEAD_SOURCES] : LEAD_SOURCES;
